import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize, firstValueFrom, map, Observable } from 'rxjs';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import {
  DoppiaMaterialitaService,
  QuestionarioValidazioneIro,
} from 'src/app/services/doppia-materialita/doppia-materialita.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { AnteprimaValidazioneIroComponent } from '../../anteprima-validazione-iro/anteprima-validazione-iro.component';
import {
  Domande,
  Opzioni,
  Sezioni,
} from 'src/app/services/informativa-aziendale/informativa-aziendale.service';

@Component({
  selector: 'app-dialog-anteprima-validazione-iro',
  standalone: false,

  templateUrl: './dialog-anteprima-validazione-iro.component.html',
  styleUrl: './dialog-anteprima-validazione-iro.component.scss',
})
export class DialogAnteprimaValidazioneIroComponent {
  @ViewChild('validazione') validazioneComponent!: AnteprimaValidazioneIroComponent;
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  private _loading = false;

  get loading() {
    return this._loading;
  }

  public strutturaValidazione: QuestionarioValidazioneIro | undefined = undefined;
  public landingPage: string = '';
  public datiValidazione: boolean = false;
  public erroreDatiValidazione: string = '';

  constructor(
    private doppiaMaterialitaService: DoppiaMaterialitaService,
    private utilityService: UtilityService,
    public dialogRef: MatDialogRef<DialogAnteprimaValidazioneIroComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      idMaterialita: string;
      idValidatore: string;
      idValidazione: string;
      codice_stato: 'NONCOMP' | 'NONINV' | 'VERDE' | 'GIALLO' | 'ROSSO';
      readOnly: boolean;
    },
  ) {}

  ngAfterViewInit(): void {
    this.getQuestionarioValidazione();
    this.getLandingPage();
  }

  public async salva(event: { questionario: QuestionarioValidazioneIro; isBozza: boolean }) {
    const dialog = this.utilityService.openDialog({
      titolo: 'Compilazione Terminata',
      descrizione: 'Le risposte non saranno modificabili. Confermi?',
      bottoni: [
        {
          nome_btn: 'No',
          id_btn: 'N',
        },
        {
          nome_btn: 'Si',
          id_btn: 'S',
        },
      ],
    });

    const valDialog = await firstValueFrom(dialog.beforeClosed());

    if (valDialog === 'N') {
      return;
    }

    this.spinnerOver.show();

    return this.doppiaMaterialitaService
      .salvaQuestionarioValidazione(
        this.data.idMaterialita,
        this.data.idValidatore,
        event.questionario,
      )
      .subscribe({
        next: (result: any) => {
          this.spinnerOver.hide();
          this.utilityService.openSnackBar('Salvataggio effettuato ', '', {
            duration: 2000,
            panelClass: ['success-snackbar'],
          });
          this.dialogRef.close();
        },
        error: (err: any) => {
          console.error('Errore durante il salvataggio della survey', err);
          this.spinnerOver.hide();
          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Errore nel salvataggio della survey',
            bottoni: [{ nome_btn: 'Chiudi' }],
          });
        },
      });
  }

  public getQuestionarioValidazione() {
    this.spinnerOver.show();

    let obs: Observable<any>;

    if (
      this.data.codice_stato === 'NONCOMP' ||
      this.data.codice_stato === 'NONINV' ||
      this.data.codice_stato === 'GIALLO'
    ) {
      //validazione non compilata
      obs = this.doppiaMaterialitaService
        .getQuestionarioValidazioneDaCompilare(this.data.idMaterialita)
        .pipe(
          map((result) => {
            // Rimappa l'oggetto questionario dal multilingua
            return result?.questionari?.length ? result.questionari[0] : null;
          }),
        );
    } else {
      //validazione compilata
      obs = this.doppiaMaterialitaService.getQuestionarioValidazioneCompilato(
        this.data.idMaterialita,
        this.data.idValidatore,
      );
    }

    obs.subscribe({
      next: (result: any) => {
        if (!result) {
          throw {
            error: {
              message: "Questionario non trovato. Riprovare più tardi o contattare l'assistenza",
            },
          };
        }
        this.strutturaValidazione = result;

        this.spinnerOver.hide();

        this.datiValidazione = true;
      },
      error: (err: any) => {
        this.spinnerOver.hide();
        console.error('errore get validazione', err.error.message);
        this.erroreDatiValidazione = err.error.message;
      },
    });
  }

  public getLandingPage() {
    this.doppiaMaterialitaService.getTemplateMailValidazioni(this.data.idMaterialita).subscribe({
      next: (template) => {
        this.landingPage = template.landingPage || '';
      },
      error: (err: any) => {
        console.error('Errore durante la chiamata al servizio', err);
      },
    });
  }

  /* 
    compilazione(elemento: any) {
  
      const idDoppiaMat = this.data.idMaterialita;
  
      if (!idDoppiaMat) {
        console.error('NESSUN ID DOPPIA MATERIALITA DA CARICARE');
        return;
      }
  
      const id = this.data.idValidazione;
  
      if (!id) {
        console.error('NESSUN ID VALIDAZIONE DA CARICARE');
        return;
      }
  
      this._loading = true;
  
      this.spinnerOver.show();
  
      this.doppiaMaterialitaService.getQuestionarioValidazioneDaCompilare(id, idDoppiaMat)
        .pipe(finalize(() => {
          this._loading = false;
          this.spinnerOver.hide();
        }))
        .subscribe({
          next: (questDaCompilare) => {
  
            this.strutturaValidazione = questDaCompilare;
  
          },
          error: (err) => {
            this.utilityService.openDialog({
              titolo: 'Attenzione',
              descrizione: err?.error?.message || 'Errore Generico',
              bottoni: [{ nome_btn: 'Ok' }]
            })
            console.error(err);
          }
        })
  
  
    } */
}
